<script>
export default {
  name: "MapBoundary",
  props: ["points", "map"],
  data() {
    return {
      rest: [],
    };
  },
  mounted() {
    var x = [
      new google.maps.LatLng(-90, -180),
      new google.maps.LatLng(-90, 0),
      new google.maps.LatLng(-90, 180),
      new google.maps.LatLng(90, 180),
      new google.maps.LatLng(90, 0),
      new google.maps.LatLng(90, -180),
    ];
    this.rest.push(x);
    if (this.points) {
      this.points.forEach(this.drawPolygon);
      this.drawOverlayPolygon();
    }
  },
  methods: {
    drawOverlayPolygon() {
      const overlay = new google.maps.Polygon({
        paths: this.rest,
        strokeColor: "#0B46EC",
        strokeOpacity: 0.25,
        strokeWeight: 2,
        fillColor: "#000000",
        fillOpacity: 0.25,
      });
      overlay.setMap(this.map);
    },
    drawPolygon(boundary) {
      const points = boundary.polygons.map((polygon) => {
        const newCords = polygon.polygonPointsWgs84.map((cords) => {
          return {
            lat: cords.X,
            lng: cords.Y,
          };
        });
        this.rest.push(newCords);
        return newCords;
      });

      points.map((cords) => {
        const boundaryPolygon = new google.maps.Polygon({
          paths: cords,
          strokeColor: "#0B46EC",
          strokeOpacity: 1,
          strokeWeight: 1,
          fillOpacity: 0,
          zIndex: 1,
        });
        boundaryPolygon.setMap(this.map);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/layered-map/MapBoundary.vue